export const HISTORY_PUSH_CALL = 'HISTORY_PUSH_CALL';
export const HISTORY_PUSH_DONE = 'HISTORY_PUSH_DONE';
export const HISTORY_PUSH_FAIL = 'HISTORY_PUSH_FAIL';

export const HISTORY_REPLACE_CALL = 'HISTORY_REPLACE_CALL';
export const HISTORY_REPLACE_DONE = 'HISTORY_REPLACE_DONE';
export const HISTORY_REPLACE_FAIL = 'HISTORY_REPLACE_FAIL';
